// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a52b6263","239":"8a1ff697","329":"1c4b90ef","455":"0e6d52f2","750":"7572ce25"}[chunkId] + ".chunk.js";
};